<div class="row d-flex align-items-center">
  <label class="col-6 required">Countries</label>
  <osn-cxb-multi-select
    class="col"
    *ngIf="countryOptions"
    [isFixedWidth]="true"
    [readonly]="readonly"
    [formControl]="countryIdsControl"
    [options]="countryOptions"
    [errorLabel]="countryIdsControl | missingCountrySelectionPrompt"
    filterPlaceholderLabel="Filter in countries..."
    filterNoEntriesFoundLabel="No country found"
    placeholder="Select target countries"
    [data-testid]="testId"
  ></osn-cxb-multi-select>
</div>
